<template>
  <div>
    <!-- {{ addresses }} -->
    <!-- model:  {{ model }} -->

    <v-text-field
      ref="ac"
      :prepend-icon="autocomplete ? 'mdi-map-marker' : 'mdi-map-marker-off'"
      @click:append="openStreetView"
      @click:prepend="toggleAddressAutocomplete"
      v-model="model"
      append-icon="mdi-google-street-view"
      @focus="handleFocus"
      @keyup="search"
      @click="search"
      @blur="resetSearch"
      @click:clear="resetModel"
      :label="label"
      dense
      autocomplete="password"
      :name="nope()"
      clearable
      :rules="requiredOption"
      :k="k"
      :readonly="readonly"
    >
      <template v-slot:append>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" class="mr-2" @click="openStreetView">
              mdi-google-street-view
            </v-icon>
          </template>
          <span>Open Street View</span>
        </v-tooltip>
      </template>
    </v-text-field>
    <!-- :rules="[validateAddress]" -->
    <v-card
      @mousemove="mouseMove"
      @mouseout="mouseOut"
      class="mt-n3 ml-1 addresses"
      v-if="addresses && addresses.length && !modelSelected"
    >
      <v-list :key="addrKey">
        <v-list-item v-for="(a, i) in addresses" :key="i">
          <v-list-item-content>
            <v-list-item-title @click="selectAddress(a)" v-text="a.address"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { readonly } from "vue";
import * as fun from "../plugins/common";
export default {
  props: {
    // value: Object,
    formModel: [Object, Array],
    parentModel: [Object, Array],
    parentKey: String,
    parModel: Object,
    label: String,
    on: Object,
    vModel: Object,
    vBind: Object,
    required: [Boolean, String],
    rules: Array,
    k: String,
    doNotUpdateModel: Boolean,
    onLoadComponent: Function,
    onAddressChange: Function,
    validateSuggestions: Boolean,
    readonly: Boolean
  },
  data: () => ({
    descriptionLimit: 60,
    places: [],
    defaultItem: true,
    isLoading: false,
    model: null,
    addrKey: 0,
    items: [],
    allItems: [],
    defaultItems: [],
    addresses: [],
    completed: false,
    APPLICATION_ID: "vLTJ6cMbW0UuB8Bs4zZ4",
    APPLICATION_CODE: "V1IB61yi2tiljthIgdLW3g",
    // APPLICATION_ID: "bkhbxZAvPomg9UidmcRP",
    // APPLICATION_CODE: "fkLIBWTyKDnE6PRwZE49K6RekB4CmyIS-CHoOZu8ZNg",
    coordinates: "",
    modelSelected: false,
    suggestionSelected: false,
    overList: false,
    myRules: [],
    myParent: null,
    requiredOption: [],
    autocomplete: true
  }),
  methods: {
    handleFocus() {
      // Use a slight delay to allow for the keyboard to fully open
      try {
        setTimeout(() => {
          this.$refs.ac.$el.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
        }, 300); // Adjust timing if needed
      } catch (error) {
        //
      }
    },
    mouseMove(t) {
      // console.log(t);
      this.overList = true;
    },
    mouseOut() {
      this.overList = false;
    },
    resetSearch(t) {
      if (!this.overList) {
        this.modelSelected = true;
      }
    },
    validateAddress() {
      var geo = fun.deepFind(this.formModel, "address.geo.location");
      if (!this.suggestionSelected && this.validateSuggestions && !geo && this.model) {
        return "Please select an address before saving.";
      }
      return true;
    },
    openStreetView() {
      var pos = this.parModel.location?.address?.geo?.location?.position;
      if (pos) {
        var coords = pos.join();
        const url = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${coords}`;
        window.open(url, "_blank");
      } else {
        const url = `https://www.google.com/maps/search/?api=1&query=${this.model}`;
        window.open(url, "_blank");
      }
      // const coords = this.coordinates.trim();
      // const isValidCoords = /^-?\d+(\.\d+)?,-?\d+(\.\d+)?$/.test(coords);
    },
    selectAddress(model) {
      this.model = model.address;
      this.overList = false;
      // console.log(a);
      var that = this;
      this.isLoading = true;
      this.modelSelected = true;
      fetch(model.href)
        .then(res => res.json())
        .then(res => {
          model.geo = res;
          // if (!that.doNotUpdateModel) {
          that.suggestionSelected = true;
          that.$emit("input", model);
          // }
          //

          // this.$root.$emit("addressChanged", model, that);
          if (this.myParent && this.myParent.onAddressChange) {
            this.myParent.onAddressChange(model, that);
          }
          if (that.on) {
            that.on.input(model);
          }
        })
        .catch(err => {
          // console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
    search(t) {
      if (this.readonly || !this.autocomplete) {
        return;
      }
      this.overList = false;
      this.modelSelected = false;
      this.suggestionSelected = false;
      var val = t.target.value;
      // if (val == this.model) {
      //   return;
      // }
      this.defaultItem = false;
      var that = this;
      //   if (this.isLoading) return;

      this.isLoading = true;
      var url =
        "https://places.cit.api.here.com/places/v1/autosuggest?at=" +
        this.coordinates +
        "&q=" +
        val +
        "&app_id=" +
        this.APPLICATION_ID +
        "&app_code=" +
        this.APPLICATION_CODE;

      fetch(url)
        .then(res => res.json())
        .then(res => {
          var places = res.results.filter(place => place.vicinity);

          that.places = places;

          that.addresses = that.places.map(place => {
            var placeInfo = {
              title: place.title,
              address:
                place.resultType == "address"
                  ? place.title + ", " + place.vicinity.replace(/<br\/>/g, ", ")
                  : place.vicinity.replace(/<br\/>/g, ", "),
              value:
                place.highlightedTitle.replace(/<br\/>/g, ", ") +
                ", " +
                place.highlightedVicinity.replace(/<br\/>/g, ", "),
              category: place.category,
              id: place.id,
              href: place.href
            };

            return placeInfo || "";
          });
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
    resetModel() {
      this.allItems = null;
      this.model = null;
      this.addresses = [];
    },
    nope() {
      return fun.nope();
    },
    restoreDefault() {
      this.allItems = this.defaultItems;
      // this.$root.$emit("addressLoaded", this);
    },
    toggleAddressAutocomplete() {
      this.autocomplete = !this.autocomplete;
    }
  },
  computed: {
    outerIcon() {
      // return false
      return this.allItems.length ? "mdi-restore" : false;
    },
    model: {
      get() {
        return this.vModel ? this.vModel.address : null;
      },
      // setter
      set(model) {
        // console.log(model);
        var that = this;

        if (model && model.href) {
          this.isLoading = true;
          fetch(model.href)
            .then(res => res.json())
            .then(res => {
              model.geo = res;
              // if (!that.doNotUpdateModel) {
              that.$emit("input", model);
              // }
              //
              // this.$root.$emit("addressChanged", model, that);
              if (this.onAddressChange) {
                this.onAddressChange(model);
              }
              if (that.on) {
                that.on.input(model);
              }
            })
            .catch(err => {
              // console.log(err);
            })
            .finally(() => (this.isLoading = false));
        } else {
          if (model && model.label) {
            this.$root.$emit("defaultAddressSelected", that, model);
          }
        }
      }
    }
  },

  mounted() {
    // this.myRules = [...this.rules, ...this.validateAddress];
    this.myParent = fun.getParentByProperty(this, "shipment"); // parent iterator
    if (this.vModel && this.vModel.address) {
      this.model = this.vModel.address;
    } else {
      if (this.vModel.length) {
        this.model = this.vModel;
      }
    }
    this.requiredOption = fun.getRule(this.required || this.vBind.required, this.label);
    this.coordinates = (this.$root.position && this.$root.position.toString()) || "40.94265,-73.88364";
    this.$root.$emit("addressLoaded", this);
    this.allItems = [];
    if (this.items) {
      this.allItems = this.items;
    }

    if (this.defaultItem && this.vModel.address) {
      this.allItems.push(this.vModel.address);
    }
  }
};
</script>
<style>
.addresses {
  max-height: 300px !important;
  overflow: auto;
}
</style>
